import React, { useRef, useCallback, useEffect, useState } from "react";
import { useDimensions } from "hooks/useDimension";
import {
  Home,
  PlantBased,
  MateriaPrima,
  Adidas,
  Hermes,
  Fios,
  Algas,
  Fluidos,
  Equilibrio,
} from "components";
import * as S from "./styles";

export const Main: React.FC = () => {
  const slideRef = useRef<HTMLDivElement>(null);
  const { width } = useDimensions();
  const [isHorizontalScroll, setIsHorizontalScroll] = useState<boolean>(false);

  const scrollSlider = useCallback((event): void => {
    slideRef.current?.scrollBy({
      left: event.deltaY,
      top: 0,
    });
  }, []);

  const checkWidth = useCallback((): void => {
    setIsHorizontalScroll(width > 1010);
  }, [width]);

  useEffect(() => {
    if (isHorizontalScroll) {
      window.addEventListener("wheel", scrollSlider);
    } else {
      window.removeEventListener("wheel", scrollSlider);
    }
    return () => {
      window.removeEventListener("wheel", scrollSlider);
    };
  }, [isHorizontalScroll, scrollSlider]);

  useEffect(() => {
    checkWidth();
  }, [checkWidth]);

  return (
    <S.Container ref={slideRef}>
      <S.SectionWrapper className="home">
        <Home />
      </S.SectionWrapper>
      <S.SectionWrapper>
        <PlantBased />
      </S.SectionWrapper>
      <S.SectionWrapper>
        <MateriaPrima />
      </S.SectionWrapper>
      <S.SectionWrapper>
        <Adidas />
      </S.SectionWrapper>
      <S.SectionWrapper>
        <Hermes />
      </S.SectionWrapper>
      <S.SectionWrapper>
        <Fios />
      </S.SectionWrapper>
      <S.SectionWrapper>
        <Algas />
      </S.SectionWrapper>
      <S.SectionWrapper>
        <Fluidos />
      </S.SectionWrapper>
      <S.SectionWrapper>
        <Equilibrio />
      </S.SectionWrapper>
    </S.Container>
  );
};
